// home-reviews.js — the "What Customers Say" carousel (home-reviews.liquid,
// Figma 13810:10445). Loaded as a module so two instances of the section
// share one evaluation.
//
// The cards live in a CSS scroll-snap track, so scrolling is the browser's
// job and this file only drives it:
//   1. the arrows step one card left or right and wrap at the ends, as the
//      client's motion reference does;
//   2. the dots jump to a card and light up the one now at the left edge;
//   3. the control row hides itself while the track has nothing to scroll
//      (three cards fit the 1357 column exactly, so a fourth review is what
//      turns the controls on) and comes back on resize;
//   4. optional autoplay, off unless the merchant turns it on, paused on
//      hover, on focus, while a pointer is down, on a hidden tab and off
//      screen, and never started under prefers-reduced-motion.
//
// The reveal is base.css's .rv on the wrapper and assets/app.js's observer;
// nothing here touches it.
(function () {
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__tmgReviews) return;
    var track = root.querySelector('[data-testi-track]');
    var controls = root.querySelector('[data-testi-controls]');
    if (!track || !controls) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-testi-card]'));
    if (!cards.length) return;
    var dots = Array.prototype.slice.call(controls.querySelectorAll('[data-testi-dot]'));
    root.__tmgReviews = true;

    // Card offsets are measured against the first card, so the track's own
    // padding and position never enter the sums.
    function offsetOf(i) { return cards[i].offsetLeft - cards[0].offsetLeft; }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function scrollable() { return maxScroll() > 1; }

    function activeIndex() {
      var x = track.scrollLeft, best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(offsetOf(i) - x);
        if (d < dist - 0.5) { dist = d; best = i; }
      }
      return best;
    }

    function go(i, instant) {
      var n = cards.length;
      i = ((i % n) + n) % n;
      track.scrollTo({
        left: Math.min(offsetOf(i), maxScroll()),
        behavior: (instant || reduced) ? 'auto' : 'smooth'
      });
    }

    // Called straight from the scroll event rather than through
    // requestAnimationFrame: rAF is paused on a hidden tab, and the dots
    // would then be stale the moment it came back. The early return keeps
    // it to one comparison per scroll event.
    var lit = -1;
    function syncDots() {
      var a = activeIndex();
      if (a === lit) return;
      lit = a;
      for (var i = 0; i < dots.length; i++) {
        var isOn = i === a;
        dots[i].classList.toggle('is-active', isOn);
        if (isOn) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
    }

    // A scrollable region has to be reachable by keyboard; a track that
    // cannot scroll is just a row of cards, so it gives the tab stop back.
    function syncControls() {
      var can = scrollable();
      controls.hidden = !can;
      if (can) track.setAttribute('tabindex', '0');
      else track.removeAttribute('tabindex');
    }

    // ---- controls ----
    var prev = controls.querySelector('[data-testi-prev]');
    var next = controls.querySelector('[data-testi-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    // At the far end the nearest card is the last one that can reach the
    // left edge, so a further step wraps round, as the reference does.
    function advance(dir) {
      if (dir > 0 && track.scrollLeft >= maxScroll() - 1) go(0);
      else if (dir < 0 && track.scrollLeft <= 1) go(cards.length - 1);
      else go(activeIndex() + dir);
    }
    function step(dir) { advance(dir); restart(); }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); restart(); });
    });

    track.addEventListener('scroll', syncDots, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'Home') { e.preventDefault(); go(0); restart(); }
      else if (e.key === 'End') { e.preventDefault(); go(cards.length - 1); restart(); }
    });

    addEventListener('resize', function () { syncControls(); syncDots(); }, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { syncControls(); syncDots(); });
    }
    syncControls();
    syncDots();

    // ---- autoplay ----
    var on = controls.getAttribute('data-autoplay') === 'true';
    var ms = (parseInt(controls.getAttribute('data-interval'), 10) || 6) * 1000;
    var timer = null, hover = false, focused = false, down = false, onScreen = true;
    function blocked() {
      return hover || focused || down || document.hidden || !onScreen || !scrollable();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() {
      stop();
      if (!on || reduced) return;
      timer = setInterval(function () { if (!blocked()) advance(1); }, ms);
    }
    if (on && !reduced) {
      root.addEventListener('mouseenter', function () { hover = true; });
      root.addEventListener('mouseleave', function () { hover = false; });
      root.addEventListener('focusin', function () { focused = true; });
      root.addEventListener('focusout', function () { focused = false; });
      track.addEventListener('pointerdown', function () { down = true; });
      addEventListener('pointerup', function () { down = false; });
      addEventListener('pointercancel', function () { down = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { onScreen = en.isIntersecting; });
        }, { threshold: 0.25 }).observe(root);
      }
      restart();
    }

    // ---- theme editor ----
    root.__tmgReviewsSelect = function (card) {
      var i = cards.indexOf(card);
      if (i > -1) { stop(); go(i); }
    };
    root.__tmgReviewsDeselect = restart;
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.reviews [data-reviews]').forEach(init);
  }
  scan();

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-testi-card]');
    var root = card && card.closest('[data-reviews]');
    if (root && root.__tmgReviewsSelect) root.__tmgReviewsSelect(card);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-reviews]');
    if (root && root.__tmgReviewsDeselect) root.__tmgReviewsDeselect();
  });
})();
